import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 md:py-20 text-center px-4">
      <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center text-foreground-400">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-5 text-lg font-medium text-foreground-950">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-600 max-w-md leading-6">{description}</p>
      )}
      <div className="mt-6 flex items-center gap-3 flex-wrap justify-center">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {actionLabel}
          </button>
        )}
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}